import { Component, OnInit, AfterViewInit, OnDestroy, Optional, Inject, Injector, Input } from '@angular/core';
import { NG_VALIDATORS, NG_ASYNC_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { InputBase } from '../../../base/input-base';

@Component({
    selector: 'aa-input-textarea',
    templateUrl: './input-textarea.component.html',
    styleUrls: [
        '../input.component.scss',
        './input-textarea.component.scss'
    ],
    providers: [{
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputTextareaComponent,
            multi: true,
        }],
    standalone: false
})
export class InputTextareaComponent extends InputBase<string> implements OnInit, AfterViewInit, OnDestroy
{
    private static identifier = 0;
    @Input() public placeholder: string | null = null;
    @Input() public maxlength: number | null = null;
    @Input() public rows: number = 10;

    constructor(
        @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
        @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
        injector: Injector
    )
    {
        super(injector);
        this.fieldId = `input-textarea-${InputTextareaComponent.identifier++}-id`;
    }

    ngOnInit ()
    {
    }

    ngAfterViewInit (): void
    {
    }

    ngOnDestroy ()
    {
    }
}
